// removed by extract-text-webpack-plugin
module.exports = {"component":"_1nGCQk2SVAO81j9xlTD0pg","btn":"_2LPDxpTBLj3NbMR3n2R0ih","label":"_3Hg5lOXqb4I0zi9E0QuO_5","input":"_3_px4qutunp4ymPNBqJb2B","register":"_2eQhBmGY-4CD8nPzFjN-I8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalInfoChange/PersonalInfoChange.scss
 ** module id = 180
 ** module chunks = 0
 **/